import React from "react";
import { Select, MenuItem, Typography, Chip } from "@mui/material";
import { observer } from "mobx-react";

import {
  SelectContainer,
  HeaderSelectContainer,
  RadioContainer,
  StyledRadio,
  StyledFormControl,
  StyledInputLabel,
  ChipName,
  ChipRole,
  TagsContainer,
  StyledPaper,
} from "./UserPermissionSelect.styled";

const UserPermissionSelect = observer(
  ({
    viewAll,
    specificView,
    handleSpecificViewChange,
    handleContactOwnerChange,
    handleRemoveUser,
    ann_user_id = "",
    status,
    annUsers,
    userId,
    handleStoreLoad,
  }) => {
    const menuProps = {
      PaperProps: {
        component: StyledPaper,
      },
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left",
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left",
      },
      style: {
        zIndex: 1,
      },
    };

    return (
      <SelectContainer data-testid="permission-select-container">
        <HeaderSelectContainer
          disabled={viewAll}
          aria-disabled={viewAll}
          data-testid="header-select-container"
        >
          <RadioContainer data-testid="radio-container">
            <StyledRadio
              data-testid="specific-view-radio"
              checked={specificView}
              onChange={handleSpecificViewChange}
              value="specific"
              name="contact-owner-radio"
              size="small"
              disabled={viewAll}
            />
            <Typography data-testid="radio-label">
              Select specific contact owners for limited access
            </Typography>
          </RadioContainer>
          <Typography data-testid="total-assigned">
            Total assigned:{" "}
            {ann_user_id === "" || ann_user_id === null || viewAll
              ? 0
              : ann_user_id?.split(",").length}
          </Typography>
        </HeaderSelectContainer>
        <StyledFormControl
          fullWidth
          size="small"
          disabled={!specificView}
          data-testid="form-control"
        >
          <StyledInputLabel>Search and select</StyledInputLabel>
          <Select
            value=""
            onChange={handleContactOwnerChange}
            label="Search and select"
            MenuProps={menuProps}
          >
            <MenuItem value="">
              <em>Unassigned</em>
            </MenuItem>
            {status !== "loading" && annUsers && annUsers.length > 0 ? (
              annUsers.map((user) => {
                const isSelected = (ann_user_id?.split(",") || []).some(
                  (selectedUserId) =>
                    selectedUserId === String(user.ann_user_id)
                );
                return (
                  <MenuItem
                    key={user.ann_user_id}
                    value={String(user.ann_user_id)}
                    disabled={isSelected}
                  >
                    <Typography component="span">
                      <ChipName data-testid={`user-name-${user.ann_user_id}`}>
                        {user.full_name}
                      </ChipName>
                      <ChipRole
                        data-testid={`user-role-${user.ann_user_id}`}
                      >{` ${user.role}`}</ChipRole>
                    </Typography>
                  </MenuItem>
                );
              })
            ) : (
              <MenuItem disabled>No users available</MenuItem>
            )}
          </Select>
          {ann_user_id?.length > 0 && !viewAll && (
            <TagsContainer>
              {annUsers
                .filter((user) =>
                  ann_user_id.includes(String(user.ann_user_id))
                )
                .map((user, index) => (
                  <Chip
                    key={user.ann_user_id}
                    label={
                      <>
                        <ChipName>
                          {user.full_name}
                        </ChipName>
                        <ChipRole>{` ${user.role}`}</ChipRole>
                      </>
                    }
                    onDelete={() => handleRemoveUser(user.ann_user_id)}
                    variant="outlined"
                  />
                ))}
            </TagsContainer>
          )}
        </StyledFormControl>
      </SelectContainer>
    );
  }
);

export default UserPermissionSelect;
